import { useState } from 'react';
import { useBranding } from './BrandingProvider';
import { DEFAULT_BRANDING } from './brandingConfig';

interface BrandLogoProps {
  /** Optional className passed through to the underlying img element. */
  className?: string;
  /** Optional inline styles merged onto the underlying img element. */
  style?: React.CSSProperties;
}

/**
 * Renders the brand logo as an <img>. Uses the `logoUrl` from the branding
 * configuration and gracefully falls back to the bundled Signers Choice logo
 * if a provided logo URL fails to load.
 */
export function BrandLogo({ className, style }: BrandLogoProps) {
  const { logoUrl, appName } = useBranding();
  const [src, setSrc] = useState(logoUrl);

  return (
    <img
      src={src}
      alt={`${appName} logo`}
      className={className}
      style={style}
      onError={() => {
        if (src !== DEFAULT_BRANDING.logoUrl) {
          setSrc(DEFAULT_BRANDING.logoUrl);
        }
      }}
    />
  );
}
